var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { types } from './mutations';
import { container } from 'tsyringe';
import { PublicJobListRepository } from 'packages/job_lists/public/PublicJobListRepository';
import { JobList } from 'packages/job_lists/JobList';
import axios from 'axios';
import env from '@/config/env';
var jobListRepo = container.resolve(PublicJobListRepository);
export var actions = {
    getListForStringId: function (_a, _b) {
        var commit = _a.commit;
        var stringId = _b.stringId, accessToken = _b.accessToken;
        return __awaiter(this, void 0, void 0, function () {
            var _c, _d, error_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        commit(types.SET_LOADING_JOB_LIST, true);
                        commit(types.SET_JOB_LIST_NOT_FOUND, false);
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        _c = commit;
                        _d = [types.SET_JOB_LIST];
                        return [4 /*yield*/, jobListRepo.getListStringId(stringId, accessToken)];
                    case 2:
                        _c.apply(void 0, _d.concat([_e.sent()]));
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _e.sent();
                        if (error_1.response.status === 404) {
                            commit(types.SET_JOB_LIST_NOT_FOUND, true);
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        commit(types.SET_LOADING_JOB_LIST, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getLandingPagesForJobListByStringId: function (_a, _b) {
        var commit = _a.commit;
        var stringId = _b.stringId, paging = _b.paging, search = _b.search, location = _b.location, accessToken = _b.accessToken;
        return __awaiter(this, void 0, void 0, function () {
            var _c, items, pagination;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit(types.SET_LOADING_LANDING_PAGES, true);
                        return [4 /*yield*/, jobListRepo.getLandingPagesForStringId(stringId, paging, search, location, accessToken)];
                    case 1:
                        _c = _d.sent(), items = _c.items, pagination = _c.pagination;
                        commit(types.SET_PAGES, items);
                        commit(types.SET_LANDING_PAGE_PAGINATION, pagination);
                        commit(types.SET_LOADING_LANDING_PAGES, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getCities: function (_a, jobListStringId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = commit;
                        _c = [types.SET_LOCATIONS];
                        return [4 /*yield*/, jobListRepo.getLocations(jobListStringId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    },
    getFirstActiveJobList: function (_a, companyId) {
        var _b;
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _c = commit;
                        _d = [types.SET_JOB_LIST];
                        return [4 /*yield*/, jobListRepo.getActiveJobList(companyId)];
                    case 1:
                        _c.apply(void 0, _d.concat([(_b = _e.sent()) !== null && _b !== void 0 ? _b : new JobList()]));
                        return [2 /*return*/];
                }
            });
        });
    },
    getPrivacyPolicyUrl: function (_a) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var url, _1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get("/api/v2/company/" + state.jobList.companyId + "/privacy-policy", { baseURL: env.JOBILLA_API_ROOT })
                                .then(function (res) { return res.data.data.url; })];
                    case 2:
                        url = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _1 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        commit(types.SET_PRIVACY_POLICY_URL, url);
                        return [2 /*return*/];
                }
            });
        });
    },
};
